import { anatomy } from '@shared/tokens/anatomy.stylex';
import * as stylex from '@stylexjs/stylex';
import { palette } from '@shared/tokens/palette.stylex.ts';

export const styles = stylex.create({
  guestListFilter: {
    display: 'flex',
    gap: anatomy['space-8'],
    ':not(#__unused__) > button': {
      padding: '8px 16px',
      fontSize: '14px',
      border: `1px solid ${palette['darked-40']}`,
    },
  },
});
